// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getAliasTimezonesById } from 'app/constants/enums/AliasTimezones/main';

/* eslint-disable max-len */
export const EUROPE_BELFAST = getAliasTimezonesById('Europe/Belfast');
export const EUROPE_BRATISLAVA = getAliasTimezonesById('Europe/Bratislava');
export const EUROPE_LJUBLJANA = getAliasTimezonesById('Europe/Ljubljana');
export const EUROPE_PODGORICA = getAliasTimezonesById('Europe/Podgorica');
export const EUROPE_SARAJEVO = getAliasTimezonesById('Europe/Sarajevo');
export const EUROPE_SKOPJE = getAliasTimezonesById('Europe/Skopje');
export const EUROPE_TIRASPOL = getAliasTimezonesById('Europe/Tiraspol');
export const EUROPE_VADUZ = getAliasTimezonesById('Europe/Vaduz');
export const EUROPE_ZAGREB = getAliasTimezonesById('Europe/Zagreb');
/* eslint-enable max-len */
